"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TemplateDivisions {
}
exports.TemplateDivisions = TemplateDivisions;
//# sourceMappingURL=TemplateDivisions.js.map